import { ANALYTICS_EXCLUDED_PATH_PREFIXES } from './config';

export type NormalizedRoute = {
  pageType: string;
  pageLabel: string;
  normalizedPath: string;
  entityId?: string;
};

const RULES: Array<{
  test: (path: string) => boolean;
  pageType: string;
  pageLabel: string;
  normalizedPath: string;
  entityIndex?: number;
}> = [
  { test: (p) => p === '/', pageType: 'home', pageLabel: 'Ana Sayfa', normalizedPath: '/' },
  {
    test: (p) => p.startsWith('/admin-panel'),
    pageType: 'admin',
    pageLabel: 'Admin Panel',
    normalizedPath: '/admin-panel/*',
  },
  {
    test: (p) => /^\/ilan-detay(?:-login|-kurumsal)?\/[^/]+$/i.test(p),
    pageType: 'listing_detail',
    pageLabel: 'İlan Detay',
    normalizedPath: '/ilan-detay/:id',
    entityIndex: 1,
  },
  {
    test: (p) => /^\/satici-profil(?:-kurumsal)?\/[^/]+$/i.test(p),
    pageType: 'seller_profile',
    pageLabel: 'Satıcı Profili',
    normalizedPath: '/satici-profil/:id',
    entityIndex: 1,
  },
  { test: (p) => p.startsWith('/gonderiler'), pageType: 'reels_feed', pageLabel: 'Gönderiler', normalizedPath: '/gonderiler' },
  { test: (p) => p === '/giris', pageType: 'login', pageLabel: 'Giriş', normalizedPath: '/giris' },
  { test: (p) => p === '/kayit', pageType: 'register', pageLabel: 'Kayıt', normalizedPath: '/kayit' },
  { test: (p) => p === '/favoriler', pageType: 'favorites', pageLabel: 'Favoriler', normalizedPath: '/favoriler' },
  { test: (p) => p === '/mesajlar', pageType: 'messages', pageLabel: 'Mesajlar', normalizedPath: '/mesajlar' },
  {
    test: (p) => p.startsWith('/conversations/'),
    pageType: 'conversation',
    pageLabel: 'Mesaj Detay',
    normalizedPath: '/conversations/:id',
    entityIndex: 1,
  },
  {
    test: (p) => p === '/profil' || p === '/profil-kurumsal',
    pageType: 'profile',
    pageLabel: 'Profil',
    normalizedPath: '/profil',
  },
  { test: (p) => p === '/ilan-ver', pageType: 'listing_create', pageLabel: 'İlan Ver', normalizedPath: '/ilan-ver' },
  {
    test: (p) =>
      p.startsWith('/masaustu_tavsiyeler') ||
      p.startsWith('/laptop-tavsiyeler') ||
      p.startsWith('/donanim-tavsiyeler'),
    pageType: 'recommendations',
    pageLabel: 'Tavsiyeler',
    normalizedPath: '/tavsiyeler',
  },
];

export function normalizeRoute(pathname: string): NormalizedRoute {
  const path = pathname.split('?')[0] || '/';
  for (const rule of RULES) {
    if (!rule.test(path)) continue;
    const segments = path.split('/').filter(Boolean);
    const entityId =
      rule.entityIndex !== undefined && segments[rule.entityIndex]
        ? segments[rule.entityIndex]
        : undefined;
    return {
      pageType: rule.pageType,
      pageLabel: rule.pageLabel,
      normalizedPath: rule.normalizedPath,
      entityId,
    };
  }
  return {
    pageType: 'other',
    pageLabel: 'Diğer',
    normalizedPath: path.length > 512 ? path.slice(0, 512) : path,
  };
}

export function isAnalyticsExcludedPath(pathname: string): boolean {
  const path = pathname.split('?')[0] || '/';
  return ANALYTICS_EXCLUDED_PATH_PREFIXES.some((prefix) => path.startsWith(prefix));
}
